import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "shared/libs/azure-msal";
import { useMsal } from "@azure/msal-react";
import { clearInfo } from "shared/stores/reducers/authSlice";
import { handleUserInfoSca, handleUserInfo } from "components/Layout/Profile";
import { useLogin, useGetRoleUserSca, useGetRoleUser } from "shared/services/auth/auth.service";
import { isBlankOrNull } from "utils";
import { jwtDecode } from "jwt-decode";
import * as notistack from "notistack";

const ErrorPage = () => {
  const navigate = useNavigate();
  const { instance, inProgress } = useMsal();

  const [accessToken, setAccessToken] = useState("");
  const graphData = useSelector(state => state.auth.graphData);
  const dispatch = useDispatch();
  const getUserInfo = useLogin();
  const getPermissionScreen = useGetRoleUser();
  const getPermissionScreenSca = useGetRoleUserSca();
  const handleClearLogin = async e => {
    try {
      e.preventDefault();
      if (graphData && inProgress === InteractionStatus.None) {
        let result = null;
        if (process.env.REACT_APP_ENV_NAME === "master") {
          result = await handleUserInfoSca(graphData, instance, dispatch, getUserInfo, getPermissionScreenSca);
        } else {
          // For support non-prod coz TASC dose have non-prod env
          result = await handleUserInfo(graphData, instance, dispatch, getUserInfo, getPermissionScreen);
        }
        if (typeof result === "boolean" && !result) {
          dispatch(clearInfo());
          return;
        }
        navigate("/");
      } else if (!graphData && inProgress === InteractionStatus.None) {
        //Redirect login again
        if (!isBlankOrNull(instance.getActiveAccount())) {
          instance.acquireTokenRedirect({
            ...loginRequest,
            scopes: [process.env.REACT_APP_SCOPES],
            account: instance.getActiveAccount(),
          });
        }
      }
    } catch (error) {
      return;
    }
  };

  const getAccessToken = async () => {
    try {
      // Get the active account
      // console.log("msalInstance", instance);
      const account = instance.getActiveAccount();
      if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
      }
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        scopes: [process.env.REACT_APP_SCOPES],
        account: account,
      });
      setAccessToken(response.accessToken);
      return `Bearer ${response.accessToken}`;
    } catch (error) {
      console.error("error", error);
      notistack.enqueueSnackbar(`Pease contact an administrator`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      // throw error;
    }
  };
  // getAccessToken().catch(error => console.error("error", error));
  useEffect(() => {
    getAccessToken();
  }, [instance]);
  return (
    <Grid
      container
      direction="column"
      height={"100vh"}
      sx={{
        justifyContent: "center",
        alignItems: "center",
      }}>
      <center>
        <ErrorOutlineIcon sx={{ fontSize: 120 }} color="error" />
      </center>
      <Typography variant="h4" color="error" gutterBottom>
        Something went worng!
      </Typography>
      <Typography variant="h4" color="error" gutterBottom>
        {/* Permission denied!, Please contact TASC. */}
        Your account has no permission please contact an administrator.
      </Typography>
      <Button
        style={{ marginTop: "25px" }}
        width={"340px"}
        variant="contained"
        color="error"
        onClick={handleClearLogin}>
        Try Again
      </Button>
      <Box
        sx={{
          maxWidth: "1100px", // Optional: limit max width
          padding: 1,
          margin: 1,
          border: "1px solid grey",
          borderRadius: 2,
        }}>
        <Typography variant="body1" sx={{ fontSize: "12px" }} color="error" gutterBottom>
          Access Token
        </Typography>
        <Typography variant="body1" sx={{ wordWrap: "break-word", color: "#000000", fontSize: "10px" }}>
          {accessToken}
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "12px" }} mt={1} color="error" gutterBottom>
          ID Token
        </Typography>
        <Typography variant="body1" sx={{ wordWrap: "break-word", color: "#000000", fontSize: "10px" }}>
          {/* {instance !== null ? `${instance.getActiveAccount().idToken}` : ""} */}
          {`${JSON.stringify(jwtDecode(instance.getActiveAccount().idToken), null, 2)}`}
          {/* {`${JSON.stringify(jwtDecode(instance.getActiveAccount().idToken), null, 2)}`} */}
          {console.log("jwtDecode", jwtDecode(instance.getActiveAccount().idToken))}
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "12px" }} mt={1} color="error" gutterBottom>
          User information
        </Typography>
        <Typography variant="body1" sx={{ wordWrap: "break-word", color: "#000000" }}>
          {instance !== null ? `username : ${instance.getActiveAccount().name}` : ""}
          <br />
          {instance !== null ? `email : ${instance.getActiveAccount().username}` : ""}
          <br />
          {instance !== null ? `localAccountId : ${instance.getActiveAccount().localAccountId}` : ""}
        </Typography>
      </Box>
    </Grid>
  );
};

export default ErrorPage;
